import { DownloadOutlined, EditFilled, QuestionCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { faRedo, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from 'antd';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CANVAS_ACTION, CONTEXT_MAIN_HEADER_ITEM, eventBus, resetViewCanvas } from '../../utils';
import ResizeForm from '../Form/ResizeForm';
import ShortcutKeysModal from '../Modal/ShortcutKeysModal';
import './styles.scss';

const COPY_STATUS = {
  ENABLE: 'ENABLE',
  SUCCESS: 'SUCCESS',
  DISABLE: 'DISABLE',
};
const MainHeader = () => {
  const undoStageLength = useSelector((appState) => appState.stateManager.stateStack.length);
  const redoStageLength = useSelector((appState) => appState.stateManager.redoStack.length);
  const isDrawingMode = useSelector((appState) => appState.board.canvasDrawingMode);
  const [isShowModal, setIsShowModal] = useState(false);
  const [copyStatus, setCopyStatus] = useState(COPY_STATUS.DISABLE);

  const checkActiveObject = () => {
    const activeObj = window.canvas.getActiveObject();
    if (!activeObj) setCopyStatus(COPY_STATUS.DISABLE);
    else if (COPY_STATUS.DISABLE === copyStatus) setCopyStatus(COPY_STATUS.ENABLE);
  };
  const onCopySuccess = () => {
    setCopyStatus(COPY_STATUS.SUCCESS);
    setTimeout(() => {
      checkActiveObject();
    }, 1000);
  };

  useEffect(() => {
    eventBus.on(CANVAS_ACTION.DRAWING, onDrawingClick);

    return () => {
      eventBus.off(CANVAS_ACTION.DRAWING, onDrawingClick);
    };
  }, [isDrawingMode]);

  useEffect(() => {
    eventBus.on(CANVAS_ACTION.COPY_SUCCESS, onCopySuccess);
    eventBus.on(CANVAS_ACTION.SELECTED_OBJECT, checkActiveObject);
    eventBus.on(CANVAS_ACTION.EXPORT_PNG, downloadImg);

    return () => {
      eventBus.off(CANVAS_ACTION.COPY_SUCCESS, onCopySuccess);
      eventBus.off(CANVAS_ACTION.SELECTED_OBJECT, checkActiveObject);
      eventBus.off(CANVAS_ACTION.EXPORT_PNG, downloadImg);
    };
  }, []);

  const toggleShortcutModal = () => {
    setIsShowModal((old) => !old);
  };

  const handleCanvasAction = (action) => {
    switch (action) {
      case CANVAS_ACTION.RESET_VIEW:
        resetViewCanvas();
        break;
      default:
        if (Object.values(CANVAS_ACTION).includes(action)) eventBus.emit(action);
        break;
    }
  };
  const onFreeDrawing = () => {
    eventBus.emit('on-free-drawing');
  };
  const onDrawingDone = () => {
    eventBus.emit('on-drawing-done');
  };
  const onDrawingClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isDrawingMode) {
      onDrawingDone();
    } else {
      onFreeDrawing();
    }
  };
  const downloadImg = () => {
    let dataURL;
    const oldViewPort = window.canvas.viewportTransform;
    const { left, top, width, height } = window.canvas.backgroundImage;
    window.canvas.setViewportTransform([1, 0, 0, 1, -left, -top]);

    dataURL = window.canvas.toDataURL({
      format: 'jpeg',
      width,
      height,
    });
    const link = document.createElement('a');
    link.download = 'image.png';
    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.canvas.setViewportTransform(oldViewPort);
  };

  const disableRedo = () => {
    if (redoStageLength) return false;
    return true;
  };

  return (
    <div className={`main-header has-menu-left`}>
      <div className="header-left" onMouseEnter={() => checkActiveObject()}>
        <Tooltip title={`${CONTEXT_MAIN_HEADER_ITEM.undo.tooltip}`}>
          <Button
            disabled={undoStageLength <= 1}
            type="link"
            className="menu-item"
            onClick={() => handleCanvasAction(CANVAS_ACTION.UNDO)}
          >
            <FontAwesomeIcon icon={faUndo} />
          </Button>
        </Tooltip>
        <Tooltip title={`${CONTEXT_MAIN_HEADER_ITEM.redo.tooltip}`}>
          <Button
            disabled={disableRedo()}
            type="link"
            className="menu-item"
            onClick={() => handleCanvasAction(CANVAS_ACTION.REDO)}
          >
            <FontAwesomeIcon icon={faRedo} />
          </Button>
        </Tooltip>
        <Tooltip
          title={
            isDrawingMode ? CONTEXT_MAIN_HEADER_ITEM.saveDrawing.tooltip : CONTEXT_MAIN_HEADER_ITEM.freeDrawing.tooltip
          }
        >
          <Button type="link" className="menu-item canvas-action" onClick={onDrawingClick}>
            <EditFilled className={classnames('icon', isDrawingMode ? 'stop-drawing' : '')} />
          </Button>
        </Tooltip>
        <Tooltip title={`${CONTEXT_MAIN_HEADER_ITEM.exportPng.tooltip}`}>
          <Button type="link" className="menu-item canvas-action" onClick={downloadImg}>
            <DownloadOutlined className="icon" />
          </Button>
        </Tooltip>
        {/* <Tooltip title="Save">
          <Button
            type="link"
            className="menu-item canvas-action"
            onClick={() => handleCanvasAction(CANVAS_ACTION.SAVE)}
          >
            <SaveOutlined className="icon" />
          </Button>
        </Tooltip>

        <Tooltip title={`${copyStatus === COPY_STATUS.SUCCESS ? 'Copied' : 'Copy'}`}>
          <Button
            type="link"
            className={`menu-item canvas-action ${copyStatus === COPY_STATUS.DISABLE ? 'disable' : ''}`}
            onClick={() => handleCanvasAction(CANVAS_ACTION.COPY)}
          >
            <CopyOutlined className="icon" />
          </Button>
        </Tooltip> */}
        <Tooltip title={`${CONTEXT_MAIN_HEADER_ITEM.resetView.tooltip}`}>
          <Button
            type="link"
            className="menu-item canvas-action"
            onClick={() => handleCanvasAction(CANVAS_ACTION.RESET_VIEW)}
          >
            <SyncOutlined className="icon" />
          </Button>
        </Tooltip>
      </div>
      <div className="header-right">
        <ResizeForm />
        <div className={classnames('menu-item', isShowModal ? 'hide-shortcut' : '')} onClick={toggleShortcutModal}>
          <Tooltip placement="bottom" title="Shortcut Keys">
            <QuestionCircleOutlined />
          </Tooltip>
        </div>
      </div>
      <ShortcutKeysModal visible={isShowModal} onClose={toggleShortcutModal} />
    </div>
  );
};
export default MainHeader;
